import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  return (
    <div className="home">
      <div className="background-video-container">
        <iframe
          className="background-video"
          src="https://www.youtube.com/embed/FoXDYHsEN5U?autoplay=1&mute=1&loop=1&playlist=FoXDYHsEN5U&controls=0&showinfo=0&modestbranding=1&disablekb=1&fs=0&iv_load_policy=3&rel=0"
          title="Craps Player League Background Video"
          frameBorder="0"
          allow="autoplay; encrypted-media"
          allowFullScreen
        ></iframe>
      </div>
      <div className="content-overlay">
        <h1>Welcome to the Craps Player League</h1>
        <p>Where the world's best craps players compete, showcase, and rank their play.</p>
        <p>Joining the league is FREE. Simply enter your information and begin your journey towards the top.</p>
        <img src="/CPL_logo-768x768.webp" alt="CPL Logo" />
        <Link to="/register" className="join-button">JOIN FOR FREE</Link>
        <div className="book-section">
          <h3 className="book-title">Get The Official Guide on Amazon Today!</h3>
          <a href="https://amzn.to/45DwR4J" target="_blank" rel="noopener noreferrer" className="book-link">
            <img src="/CPL_Book-695x1024.webp" alt="CPL Guide Book" className="book-image" />
          </a>
          <a href="https://amzn.to/45DwR4J" target="_blank" rel="noopener noreferrer" className="order-button">
            Order Now
          </a>
        </div>

        <div className="youtube-section">
          <a href="https://www.youtube.com/@holyrollr" target="_blank" rel="noopener noreferrer" className="youtube-link">
            <div className="youtube-icon">
              <span className="play-icon">▶</span>
            </div>
            <span className="youtube-text">Watch on YouTube</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Home;